/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const SettingsSubpage = defineComponent({
  setup() {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-6">
        <div class="">
          <h2 class="text-2xl font-bold mb-2 flex items-center gap-2">
            <span class="material-symbols-outlined text-primary">settings</span>
            {t("customer.account.settings")}
          </h2>
          <p class="text-base-content/60">
            {t("customer.account.settings_copy")}
          </p>
        </div>

        <div class="rounded-2xl border border-base-300 bg-base-200/40 px-6 py-14 text-center">
          <span class="mx-auto grid size-14 place-items-center rounded-2xl bg-base-200 text-base-content/30">
            <span class="material-symbols-outlined text-3xl" aria-hidden="true">
              construction
            </span>
          </span>
          <h3 class="mt-4 text-lg font-bold text-base-content">
            {t("customer.account.coming_soon")}
          </h3>
          <p class="mx-auto mt-1 max-w-sm text-sm text-base-content/60">
            {t("customer.account.settings_coming_soon_copy")}
          </p>
        </div>
      </div>
    );
  },
});
